'use strict';

// サイドバー（layouts/_sidebar）の開閉とツールチップ
// - 992px 以上: <html> の sidebar-collapsed を切り替え、Cookie（sidebar_state=collapsed）に保存する
// - 768〜991px: <html> の sidebar-overlay-open を切り替え、パネルを本文の上に重ねて開く（保存しない）
// <html> の属性は Turbolinks の遷移で差し替わらないため、切り替えたクラスは遷移後も残る
(function () {
  const COOKIE_NAME = 'sidebar_state';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
  const root = document.documentElement;
  const wideQuery = window.matchMedia('(min-width: 992px)');
  const hoverQuery = window.matchMedia('(hover: hover)');

  function isOverlayRange() {
    return window.matchMedia('(min-width: 768px) and (max-width: 991.98px)').matches;
  }

  // いまアイコン列（ラベルが見えない状態）か
  function isCollapsed() {
    if (wideQuery.matches) return root.classList.contains('sidebar-collapsed');
    return !root.classList.contains('sidebar-overlay-open');
  }

  function saveCollapsed(collapsed) {
    if (collapsed) {
      document.cookie = `${COOKIE_NAME}=collapsed; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
    } else {
      document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
    }
  }

  // 開閉ボタンのラベル・aria-expanded と、ユーザーメニューの開く向きを今の状態に合わせる
  function syncState() {
    const collapsed = isCollapsed();
    document.querySelectorAll('.js-sidebar-toggle').forEach((button) => {
      const i18n = JSON.parse(button.dataset.i18n || '{}');
      const label = collapsed ? i18n.open : i18n.close;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-expanded', String(!collapsed));
      button.setAttribute('data-bs-title', label);
      const tooltip = window.bootstrap && window.bootstrap.Tooltip.getInstance(button);
      if (tooltip) tooltip.setContent({ '.tooltip-inner': label });
    });
    document.querySelectorAll('.app-sidebar__user').forEach((el) => {
      el.classList.toggle('app-dropdown--up', !collapsed);
      el.classList.toggle('app-dropdown--right', collapsed);
    });
  }

  function hideTooltips() {
    if (!window.bootstrap) return;
    document.querySelectorAll('.js-sidebar-tooltip').forEach((el) => {
      const tooltip = window.bootstrap.Tooltip.getInstance(el);
      if (tooltip) tooltip.hide();
    });
  }

  function closeOverlay() {
    if (!root.classList.contains('sidebar-overlay-open')) return;
    root.classList.remove('sidebar-overlay-open');
    syncState();
  }

  function toggle() {
    hideTooltips();
    if (wideQuery.matches) {
      const collapsed = root.classList.toggle('sidebar-collapsed');
      saveCollapsed(collapsed);
    } else if (isOverlayRange()) {
      root.classList.toggle('sidebar-overlay-open');
    }
    syncState();
  }

  function initTooltips() {
    if (!window.bootstrap) return;
    document.querySelectorAll('.js-sidebar-tooltip').forEach((el) => {
      window.bootstrap.Tooltip.getOrCreateInstance(el, {
        container: 'body', placement: 'right', trigger: 'hover', customClass: 'app-tooltip app-sidebar-tooltip', offset: [0, 8]
      });
    });
  }

  function disposeTooltips() {
    if (!window.bootstrap) return;
    document.querySelectorAll('.js-sidebar-tooltip').forEach((el) => {
      const tooltip = window.bootstrap.Tooltip.getInstance(el);
      if (tooltip) tooltip.dispose();
    });
  }

  // サイドバー上のホイールで本文がスクロールしないようにする
  // 本体がその向きにまだスクロールできるときだけ通常どおり動かし、それ以外（端に達した・中身が収まっている・
  // 上部やユーザー欄の上）は止める。overscroll-behavior はスクロールできない要素では効かないため JS で扱う
  function canScroll(el, deltaY) {
    if (deltaY < 0) return el.scrollTop > 0;
    if (deltaY > 0) return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
    return false;
  }

  function guardWheel(event) {
    if (event.ctrlKey) return; // ピンチ操作（拡大縮小）は妨げない
    const body = event.target.closest('.app-sidebar__body');
    if (body && canScroll(body, event.deltaY)) return;
    event.preventDefault();
  }

  // ラベルが見えているときとホバーのない端末では、ツールチップを出さない
  document.addEventListener('show.bs.tooltip', (event) => {
    if (!event.target.closest('.app-sidebar')) return;
    if (!hoverQuery.matches || !isCollapsed()) event.preventDefault();
  });

  // 閉じているときはユーザーメニューを右へ開く（開く直前に向きを今の状態に合わせる）
  $(document).on('app-dropdown:show', '.app-sidebar__user', syncState);

  $(document).on('click', '.js-sidebar-toggle', toggle);
  $(document).on('click', '.js-sidebar-backdrop', closeOverlay);
  $(document).on('keydown', (event) => {
    if (event.key === 'Escape') closeOverlay();
  });
  $(document).on('turbolinks:before-visit', closeOverlay);
  $(document).on('turbolinks:before-cache', disposeTooltips);
  $(document).on('turbolinks:load', () => {
    syncState();
    initTooltips();
    // preventDefault するため passive: false で登録する（body は遷移ごとに差し替わるので毎回付け直す）
    document.querySelectorAll('.app-sidebar').forEach((el) => {
      el.addEventListener('wheel', guardWheel, { passive: false });
    });
  });

  // 画面幅をまたいだら、重ねて開いたパネルを閉じて表示を合わせる
  const resync = () => {
    root.classList.remove('sidebar-overlay-open');
    syncState();
  };
  if (wideQuery.addEventListener) {
    wideQuery.addEventListener('change', resync);
  } else {
    wideQuery.addListener(resync);
  }
})();
